<template>
 <v-content class="grey pb-5 lighten-4">
    <v-toolbar flat class="blue-grey lighten-4 elevation-2">
      <v-toolbar-title>Dados Bancários do Colaborador</v-toolbar-title>
    </v-toolbar>

    <v-form>
      <v-layout row wrap>
        <v-flex md9 xs12>
          <v-text-field
            label="CPF"
            append-icon="vignette"
            v-on:keyup.enter="buscaDadosBancarios"
            v-model="fornecedorDigitado"
            @input="$emit('receberBusca', $event)"
            :readonly="!podeEditar"
          ></v-text-field>
        </v-flex>

        <v-flex md3 xs12>
          <v-btn class="white--text" color="#005ca3" @click="buscaDadosBancarios" :disabled="loadingBusca || !podeEditar">
            <span v-if="!loadingBusca">Filtrar</span>
            <v-progress-circular v-else indeterminate color="blue"></v-progress-circular>
          </v-btn>
        </v-flex>
        <v-flex md12 xs12>
          <v-text-field
            label="Nome do Favorecido"
            append-icon="face"
            v-model="fornecedor.nome"
            :readonly="true"
          ></v-text-field>
        </v-flex>

        <v-flex xs12 v-if="fornecedor.dadosBancarios.length > 0">
          <v-card class="pb-3">
            <v-card-title class="blue-grey lighten-4">Dados Bancários</v-card-title>
            <v-layout row wrap class>
              <v-flex xs12 md12 class="pb-0">
                <p
                  style="text-align: center;"
                  class="v-label ml-3 mt-3"
                >Selecione uma conta bancária:</p>
              </v-flex>
              <v-flex xs12>
                <v-data-table
                  :items="fornecedor.dadosBancarios"
                  :headers="headersProvider"
                  no-data-text="Selecione um fornecedor."
                  hide-actions
                >
                  <template slot="items" slot-scope="props">
                    <tr>
                      <td>
                        <v-checkbox
                          @change="selecionouConta($event, props.index)"
                          v-model="props.item.selecionado"
                          :disabled="fornecedor.dadosBancarios.length == 1 || props.item.selecionado || !podeEditar"
                          class="ml-3 mt-2"
                        ></v-checkbox>
                      </td>
                      <td>{{ props.item.banco }}</td>
                      <td>{{ props.item.agencia }}</td>
                      <td>{{ props.item.conta }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
  </v-content>
</template>
<script>
import axios from "axios";

export default {
  props: {
    podeEditar: {
      type: Boolean,
      default: false
    },
    fornecedorRecebido: {
      type: Object
    }
  },
  watch: {
    fornecedorRecebido: {
      handler(val) {
        this.fornecedorDigitado = val.fornecedorDigitado;
        this.fornecedor.dadosBancarios = val.fornecedor.dadosBancarios;
        this.fornecedor.nome = val.fornecedor.nome;
        this.fornecedor.id = val.fornecedor.id;
      },
      deep: true
    }
  },
  data() {
    return {
      fornecedorDigitado: "",
      favorecido: "",
      banco: "",
      agencia: "",
      contaCorrente: "",
      loadingBusca: false,
      fornecedor: {
        dadosBancarios: []
      },
      headersProvider: [
        { text: "Selecionar", value: "", sortable: false },
        { text: "Banco", value: "banco", sortable: false },
        {
          text: "Agência",
          value: "agencia",
          align: "left",
          sortable: false
        },
        { text: "Conta", value: "conta", align: "left", sortable: false }
      ]
    };
  },
  methods: {
    buscaDadosBancarios() {
      this.loadingBusca = true;
      if (this.fornecedorDigitado == null || this.fornecedorDigitado == "") {
        this.loadingBusca = false;
        return;
      }

      let numeroDocumento = this.fornecedorDigitado
        .replace(".", "")
        .replace(".", "")
        .replace("-", "")
        .replace("/", "");
      axios({
        method: "GET",
        url: `/fornecedores/busca?fornecedor=${numeroDocumento}`,
        responseType: "json",
        headers: {
          Authorization: `Bearer ${this.usuarioAutenticado.token}`,
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      })
        .then(async resposta => {
          resposta.data.dadosBancarios = resposta.data.dadosBancarios.filter(
            i => i.estaAtivo
          );
          await resposta.data.dadosBancarios.map((i, index) => {
            if (index == 0) i.selecionado = true;
            else i.selecionado = false;
          });
          this.fornecedor = resposta.data;
          await this.$emit("receberFornecedor", this.fornecedor);
        })
        .catch(erro => {
          console.error("Ocorreu um erro ao tentar buscar por fornecedor");
          console.error(erro);
        })
        .finally(f => {
          this.loadingBusca = false;
        });
    },
    async selecionouConta(event, index) {
      for (let i = 0; i < this.fornecedor.dadosBancarios.length; i++) {
        const element = this.fornecedor.dadosBancarios[i];
        if (i != index) element.selecionado = false;
      }
      this.fornecedor.dadosBancarios = [...this.fornecedor.dadosBancarios];
      await this.$emit("receberFornecedor", this.fornecedor);
    }
  },
  computed: {
    usuarioAutenticado() {
      return this.$store.getters.usuarioAutenticado;
    }
  }
};
</script>